<template>
    <div :class="$store.state.premiumProfile ? 'sidebar premiumStyle' : 'sidebar'"
        :data-color="$store.state.premiumProfile ? '' : backgroundColor" :data-image="backgroundImage"
        :data-active-color="activeColor">

        <div class="sidebar-wrapper sidebarStyle" ref="sidebarScrollArea" style="background-color: #1F2049">
            <div class="logo">
                <img v-if="esSelfi" src="static/img/logo_selfibar_numier_original.svg" style="width: 100%; margin: 0px; text-align: center;" alt="">
                
                <a class="logo-mini" href="https://www.numier.com/online">
                    <div class="logo-img" style="background: none;" v-if="!esSelfi">
                        <img :src="logo" alt="">
                    </div>
                </a>
                <a v-if="!esSelfi" href="https://www.numier.com/online" class="simple-text logo-normal" style="font-family: 'Numier', Arial, Helvetica, sans-serif;">
                    {{ title }}
                </a>
            </div>
            <!-- <img v-if="esSelfi" src="static/img/logo_selfibar_numier_original.svg" style="width: 100%; margin: 0px; text-align: center;" alt=""> -->
            <slot>

            </slot>
            <ul class="nav">
                <slot name="links">
                    <sidebar-item v-for="(link, index) in sidebarLinks" :key="link.name + index" :link="link">

                        <sidebar-item v-for="(subLink, index) in link.children" :key="subLink.name + index"
                            :link="subLink">
                        </sidebar-item>
                    </sidebar-item>
                </slot>

            </ul>
        </div>
    </div>
</template>
<script>
export default {
    name: 'sidebar',
    props: {
        title: {
            type: String,
            default: 'Numier Online'
        },
        backgroundColor: {
            type: String,
            default: 'black',
            validator: (value) => {
                let acceptedValues = ['', 'blue', 'azure', 'green', 'orange', 'red', 'purple', 'black']
                return acceptedValues.indexOf(value) !== -1
            }
        },
        backgroundImage: {
            type: String,
            default: 'assets/img/numier-blue-background.png'
        },
        activeColor: {
            type: String,
            default: 'success',
            validator: (value) => {
                let acceptedValues = ['primary', 'info', 'success', 'warning', 'danger']
                return acceptedValues.indexOf(value) !== -1
            }
        },
        logo: {
            type: String,
            default: 'static/img/numier-white-icon.svg'
        },
        sidebarLinks: {
            type: Array,
            default: () => []
        },
        autoClose: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            esSelfi : false,
        }
    },

    provide() {
        return {
            autoClose: this.autoClose
        }
    },
    computed: {
        sidebarStyle() {
            // console.log(this.$store.state.premiumProfile)
            // if(this.$store.state.premiumProfile){

            //     return {
            //         backgroundImage: `url()`
            //     }
            // }

            return {
                backgroundImage: `url(${this.backgroundImage})`
            }
        }
    },
    created() {
        this.checkIsSelfi();
    },
    methods: {
        async initScrollBarAsync() {
            await import('perfect-scrollbar/dist/css/perfect-scrollbar.css')
            const PerfectScroll = await import('perfect-scrollbar')
            PerfectScroll.initialize(this.$refs.sidebarScrollArea)
        },

        isPremium() {
            console.log(this.$store.state.premiumProfile)
            return this.$store.state.premiumProfile;
        },
         
        checkIsSelfi() {
            let vm = this;

            const esSelfiCookie = document.cookie
                .split("; ")
                .find((row) => row.startsWith("esSelfi="));

            // Verificar si la cookie existe antes de intentar acceder a su valor
            if (esSelfiCookie) {
                vm.esSelfi = esSelfiCookie.split("=")[1];
            } else {
                vm.esSelfi = false;
            }
        },
    },
    mounted() {
        this.initScrollBarAsync()
    },
    beforeDestroy() {
        if (this.$sidebar.showSidebar) {
            this.$sidebar.showSidebar = false
        }
    }
}

</script>
<style lang="scss" scoped>
/*.premiumStyle {
    opacity: 1 !important;
    background: #142330 !important;
}*/

.sidebar-wrapper {
    background-size: cover;
    background-image: linear-gradient(rgba(1,1,1,0.5), rgba(1,1,1,0.5)), url('~@/assets/img/numier-blue-background.png');
    background-position: center center;
}

@media (min-width: 992px) {

    .navbar-search-form-mobile,
    .nav-mobile-menu {
        display: none;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/SidebarPlugin/SideBar.vue